import { useMediaQuery } from 'react-responsive';

export const OnlyHover = ({ children, showBox }) => {
  const onlyHover = useMediaQuery({
    query: '(hover: hover)',
  });
  return onlyHover || (!onlyHover && showBox) ? children : null;
};

export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({
    minDeviceWidth: 768,
  });
  return isDesktop ? children : null;
};
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxDeviceWidth: 767 });
  return isMobile ? children : null;
};
